/**
 * Etiketter for StcTrans.LineType / StcTransOrder.OrderType. Denne kodelisten finnes ikke i
 * StatusCodes (StatusType 3 dekker bare 1 og 4), så den holdes her — ett sted — og brukes som
 * `customLabels` på StatusBadge. Ikke dupliser listen i komponenter.
 */
export const STC_TRANS_LINE_TYPE_LABELS: Record<number, string> = {
  0: 'Varemottak',
  1: 'Korreksjon',
  2: 'Overføring',
  3: 'Korreksjon (GR)',
  4: 'Lagertelling',
};
